// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_screen__Tfj1s > div {
  height: 100vh; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/BoothScreen/styles.module.scss"],"names":[],"mappings":"AAGA;EAEI,aAAa,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n\n.screen {\n  & > div {\n    height: 100vh;;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `styles_screen__Tfj1s`
};
export default ___CSS_LOADER_EXPORT___;
